import gsap from "gsap";
import MorphSVGPlugin from "gsap/MorphSVGPlugin";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";
import { GSDevTools, SplitText } from "gsap/all";

gsap.registerPlugin(MorphSVGPlugin, SplitText, GSDevTools);

// Export element from Figma as SVG. Ensure 'Include "id" attribute' is on in Export settings
// Optimise and prettify with SVGOMG. Check all settings except for:
// - Remove xmlns
// - Clean up IDs

// Replace the pattern xlink:href with #svg-noise
// Update #tubesA__2a to use #pattern2

export default class TextHero extends DefaultBlock {
	init() {
		const selector = gsap.utils.selector(this.block);
		this.DOM = {
			svg: selector("#text-hero-svgs svg"),
			heading: this.block.querySelector("#text-hero__heading"),
		};

		this.addTimeline();
	}

	addTimeline() {
		gsap.to(this.DOM.heading, {
			autoAlpha: 1,
			duration: 1,
			ease: "power4.inOut",
		});

		watchPreferredMotion(() => {
			const tl = gsap.timeline({ paused: true });
			const split = new SplitText(this.DOM.heading, { type: "chars" });

			split.chars.forEach((obj, i) => {
				let currentCharacter = obj.innerText;
				let characters = ["T", "e", "x", "t"].filter(
					(char) => char !== currentCharacter
				);
				let randomCharacter = gsap.utils.random(characters);
				let svg = this.DOM.svg[i].outerHTML;
				let svgFilter = this.DOM.svg.filter((svg) => svg !== this.DOM.svg[i]);
				let svgTwo = gsap.utils.random(svgFilter).outerHTML;
				let newHTML = `<div class="originalText" aria-hidden="true">${currentCharacter}</div><div class="svg">${svg}</div><div class="cloneText">${randomCharacter}</div><div class="svg">${svgTwo}</div><div class="svg">${svg}</div><div class="cloneText">${randomCharacter}</div><div class="svg">${svg}</div><div class="cloneText">${randomCharacter}</div><div class="svg">${svgTwo}</div><div class="svg">${svg}</div><div class="cloneText">${randomCharacter}</div><div class="originalTextTwo">${currentCharacter}</div>`;
				let eHTML = `<div class="originalText">${currentCharacter}</div><div class="svg">${svg}</div><div class="cloneText">${randomCharacter}</div><div class="svg">${svgTwo}</div><div class="svg">${svg}</div><div class="svg">${svg}</div><div class="cloneText">${randomCharacter}</div><div class="svg">${svgTwo}</div><div class="svg">${svg}</div><div class="cloneText">${randomCharacter}</div><div class="cloneText">t</div><div class="originalTextTwo">${currentCharacter}</div>`;
				let firstNewHTML = `<div class="originalText">${currentCharacter}</div><div class="svg">${svg}</div><div class="svg">${svgTwo}</div><div class="svg">${svg}</div><div class="originalTextTwo">${currentCharacter}</div>`;

				if (i === 1) {
					obj.innerHTML = eHTML;
				} else {
					obj.innerHTML = newHTML;
				}

				obj.childNodes.forEach((child, index) => {
					gsap.set(child, {
						yPercent: index * 100,
						autoAlpha: 1,
					});
					tl.to(
						child,
						{
							ease: "power4.inOut",
							yPercent: "-=1100",
						},
						i * 0.05
					);
				});

				gsap.to(tl, {
					progress: 1,
					duration: 2.5,
					ease: "none",
				});
			});
		});
	}
}
